import {isNil} from 'ramda';

import {ContactPersonRoleType} from '@dms/api/customer';
import type i18nType from '@dms/i18n';

import {Nullish} from 'shared/web';

const CONTACT_PERSON_ROLE_TYPE_LABELS: Record<ContactPersonRoleType, string> = {
  executive: 'entity.person.labels.roleTypes.executive',
  procurator: 'entity.person.labels.roleTypes.procurator',
  accountant: 'entity.person.labels.roleTypes.accountant',
  driver: 'entity.person.labels.roleTypes.driver',
  employee: 'entity.person.labels.roleTypes.employee',
  other: 'entity.person.labels.roleTypes.other',
};

export const getContactPersonRoleTypeOptions = (i18n: typeof i18nType) =>
  Object.entries(CONTACT_PERSON_ROLE_TYPE_LABELS).map(([value, labelKey]) => ({
    value,
    label: i18n.t(labelKey),
  }));

export const getContactPersonRoleTypeName = (
  i18n: typeof i18nType,
  roleType: ContactPersonRoleType | Nullish
) => (isNil(roleType) ? null : i18n.t(CONTACT_PERSON_ROLE_TYPE_LABELS[roleType]));
